import { RootState } from '../index.ts';

export const selectAuth = (state: RootState) => state.auth;

export const selectIsDemoUser = (state: RootState): boolean => {
  const authState = selectAuth(state);
  return authState.user?.preferred_username === 'demo-user';
};
